import { render, staticRenderFns } from "./STErrorsInput.vue?vue&type=template&id=2317838a"
import script from "./STErrorsInput.vue?vue&type=script&lang=ts"
export * from "./STErrorsInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports